import { render } from "./Formulas.vue?vue&type=template&id=4cf3723d"
import script from "./Formulas.vue?vue&type=script&lang=js"
export * from "./Formulas.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__